import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseNoticeEnrolSelect.module.scss'

import SvgMyhouseNoticeSelectArrow from '@Root/ui/images/myhouse/myhouse_notice_select--arrow.svg'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  selectItem?: any
  handleChange?: any
  initialCategory?: string
}

const MyhouseNoticeEnrolSelect: React.FC<Props> = ({ selectItem, handleChange, initialCategory }: Props) => {
  const handleChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    handleNclick(NCLICK.MY_HOUSE.NOTICE_ENROL.NOTICE_TYPE_SELECT[event.target.value], event)
    handleChange(event.target.value)
  }

  return (
    <div className={cx('myhouse_select_area')}>
      <select
        className={cx('myhouse_notice_select')}
        onChange={handleChangeSelect}
        onClick={handleNclickMix(NCLICK.MY_HOUSE.NOTICE_ENROL.NOTICE_TYPE)}
        value={initialCategory}
        defaultValue={''}
      >
        {/* IOS에서는 hidden이 작동하지 않으며, value="" 있어야 iOS에서 오동작하지 않음 QA#1933 */}
        <option value="" disabled>
          공지 타입을 선택해 주세요.
        </option>
        {selectItem.map((item: { category: string; text: string }, index: number) => (
          <option value={item.category} key={index}>
            {item.text}
          </option>
        ))}
      </select>
      <SvgMyhouseNoticeSelectArrow />
    </div>
  )
}

// 마크업확인용 임시 props
MyhouseNoticeEnrolSelect.defaultProps = {
  selectItem: ['관리사무소', '입주자 대표 회의', '입주민공지', '지자체공지', '기타공지'],
}

export default MyhouseNoticeEnrolSelect
